import { trackOptimizelyEvent, EVENT_KEYS } from '../../../../lib/optimizely';

const trackMakeModelChange = () => {
  trackOptimizelyEvent(EVENT_KEYS.MAKE_MODEL_ADVANCED_CHANGE);
  trackOptimizelyEvent(EVENT_KEYS.TOTAL_FILTER_CHANGE);
};

export default trackMakeModelChange;
